<template>
  <interface-modal
    :modal-open="engravingVisible"
    @close="closeEngraving"
  >
    <engraving-screen
      :key="screenKey"
      v-bind="engravingContext[ringIndex]"
      :rings-length="ringLength"
      :current-ring-index="ringIndex"
      @addEngravingToCart="addEngravingToCart"
      @closeEngraving="closeEngraving"
    />
  </interface-modal>
</template>
<script>
import EngravingScreen from '~/components/screens/EngravingScreen'
import InterfaceModal from '~/components/nacelle/InterfaceModal'
import { mapGetters } from 'vuex'
import get from 'lodash/get'
export default {
  components: {
    InterfaceModal,
    EngravingScreen
  },
  props: {
    engravingContext: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ringLength: this.engravingContext.length,
      ringIndex: 0
    }
  },
  computed: {
    ...mapGetters('engraving', ['engravingVisible']),
    screenKey() {
      const evgravingContext = this.engravingContext
      const ringIndex = this.ringIndex
      const currentRing = evgravingContext[ringIndex]
      const handle = get(currentRing, 'product.handle')
      const variantId = get(currentRing, 'variant.id')

      return `${ringIndex}-${handle}-${variantId}`
    }
  },
  watch: {
    engravingContext() {
      this.ringLength = this.engravingContext.length;
    }
  },
  methods:{
    addEngravingToCart(engravingState) {
      if (this.ringIndex + 1 < this.ringLength) {
        this.ringIndex++
      }
      this.$emit('addEngravingToCart', engravingState)
    },
    closeEngraving() {
      this.$emit('closeEngraving')
      this.ringIndex = 0
      this.ringLength = 0
    }
  }
}

</script>
<style lang="scss" scoped>

</style>

